import {
    SET_PERMISSIONS,
    SET_USER_PERMISSIONS,
    SET_USER_ROLE,
    LOADING_COMPONENT_PERMISSION,
    LOADING_USER_PERMISSION
} from "../../types";

import axios from "axios";
import { isEmptyObj } from "../../../helpers";
import { handleError } from "../error";
import { getCurrentUserContact } from "../contacts/contacts";

//  NAME: getPermissions
//  PARENT: InitPermission
//  DESC: It takes in a component name and use that as component value
//  DESC: It dispatches a SET_PERMISSIONS action with component name and data
//  DESC: Component name will be use as global state reference

export const getPermissions = component => async dispatch => {
    try {
        await dispatch({
            type: LOADING_COMPONENT_PERMISSION,
            payload: true
        });
        const result = await axios.get(`/permissions?component=${component}`);
        await dispatch({
            type: SET_PERMISSIONS,
            payload: {
                component,
                data: result.data
            }
        });

        await dispatch({
            type: LOADING_COMPONENT_PERMISSION,
            payload: false
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

//  NAME: getUserPermissions
//  PARENT: InitPermission
//  DESC: This method will get all assigned user's permissions
//  DESC: It dispatch a SET_USER_PERMISSIONS action with data and set to
//  DESC: global redux state

export const getUserPermissions = () => async dispatch => {
    try {
        const result = await axios.get("/permissions/user");

        dispatch({
            type: SET_USER_PERMISSIONS,
            payload: result.data.permissions
        });

        dispatch({
            type: SET_USER_ROLE,
            payload: result.data.role
        });

        dispatch({
            type: LOADING_USER_PERMISSION,
            payload: false
        });
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

//  NAME: CanI
//  PARENT: hasMany - method will be called when needed
//  DESC: requests variable comes in as an Array or String with one or more items
//  DESC: Method will check data type first then move on comparation to see if
//  DESC: User has those specific permissions
//  DESC: Method returns truthy or falsy
//  CanI accepts a string or array of permission(s). It returns a Promise ; Thus, It needs to be triggered inside an async function and wait for result as boolean
export const CanI = requests => async(dispatch, getState) => {
    try {
        const arrType = Array.isArray(requests);
        const { permissions: { userPermissions = [] } } = getState();
        if (arrType && userPermissions.length !== 0) {
            return requests.every(request => userPermissions.includes(request));
        }
        else if (typeof requests === "string" && requests !== "undefined") {
            return userPermissions.includes(requests);
        }
        console.debug({
            error: "CanI expects String or Array " + requests === "undefined" ?
                "undefined" :
                typeof requests + " received.",
            requests
        });
        return true;
    }
    catch (error) {
        dispatch(handleError(error));
        return false;
    }
};

export const hasRole = role => async(dispatch, getState) => {
    try {
        const { permissions: { userRole } } = getState();
        return role === userRole;
    }
    catch (error) {
        dispatch(handleError(error));
        return false;
    }
};

//  NAME: UserAccess
//  PARENT: hasMany - method will be called when needed - usually when compoenent first loaded
//  DESC: Method takes in component<String> verb<String> phase<Number>
//  DESC: Method will use those values and reference to the correct access permission
//  DESC: Method returns truthy or falsy

export const UserAccess = (component, verb, phase) => async(
    dispatch,
    getState
) => {
    try {
        const { permissions: { [component]: Component } } = getState();
        if (isEmptyObj(Component)) {
            return;
        }

        if (!Component) {
            throw new ReferenceError("Component Not Found!");
        }

         
        return Component[verb][phase];
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

//  NAME: InitPermission
//  PARENT: PrivateRoute.js
//  DESC: Method takes in component<String>
//  DESC: Method will dispatch necessary methods to get data
//  DESC: Method responsible for Setting and Removing Permission Loading

export const InitPermission = ({ component }) => async dispatch => {
    try {
        await dispatch(getCurrentUserContact());
        await dispatch(getPermissions(component));
        await dispatch(getUserPermissions());
    }
    catch (error) {
        dispatch(handleError(error));
    }
};
